import { ErrorCodeType } from "application/models/IError";
import {
  PrintOrderType,
  SpoolerStatus,
} from "components/layoutsPrinter/IPrintOrder";
import LayoutPrinter, {
  ILayoutPrinterHandler,
} from "components/layoutsPrinter/LayoutPrinter";
import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import { PrintStatus } from "domains/order/agreggates/order/Order";
import { IPrintRepository } from "domains/order/interfaces/repositories/iprintRespository";
import { useAppInsights } from "Infrastructure/repositories/appInsights/AppInsights";
import { LocalPrintRepository } from "Infrastructure/services/cefSharpService/local/_LocalPrintRepository";
import { IOrderLog } from "modules/order/domain/models/IOrderLog";
import { localPrintUseCase } from "modules/print/application/useCases/LocalPrintUseCase";
import React, { createRef, FC, useCallback, useEffect } from "react";
import { GetError } from "utils/GetError";
import { useShallow } from "zustand/react/shallow";
import { PrinterStore, usePrinterStore } from "./PrinterStore";

export interface IPrinterProviderProps {
  kiosk: Kiosk | null;
}

export const layoutPrinterRef = createRef<ILayoutPrinterHandler>();
const NewPrinterProvider: FC<IPrinterProviderProps> = ({ kiosk }) => {
  const printRepository: IPrintRepository = LocalPrintRepository();
  const { addLog } = useAppInsights();
  const [
    setSpoolerStatus,
    spoolerStatus,
    removeOrder,
    getOrderToPrint,
    ordersToPrint,
  ] = usePrinterStore(
    useShallow((state: PrinterStore) => [
      state.setSpoolerStatus,
      state.spoolerStatus,
      state.removeOrder,
      state.getOrderToPrint,
      state.ordersToPrint,
    ])
  );

  const addOrderLog = useCallback(
    async (
      order: IOrderLog | null,
      message: string,
      printStatus: PrintStatus,
      error?: any
    ) => {
      try {
        if (order) {
          let orderLog = {
            ...order,
            printStatus: PrintStatus[printStatus],
            error,
          };
          addLog("PrinterProvider", { message, orderLog });
          // await locaStorageOrderRepository.add(
          //   orderLog,
          //   message,
          //   undefined,
          //   printStatus
          // ); //TODO: Removido porque alguma impressora não possuem controle de impressão
        }
      } catch (error) {
        GetError(
          error,
          "addOrderLog",
          "NewPrinterProvider",
          "Falha ao adicionar log",
          ErrorCodeType.PRINT
        );
      }
    },
    [addLog]
  );

  const printOrderHandler = useCallback(
    async (_kiosk: Kiosk) => {
      const orderToPrint = getOrderToPrint();
      try {
        await localPrintUseCase(
          layoutPrinterRef,
          printRepository,
          orderToPrint,
          _kiosk
        );
        if (orderToPrint.type === PrintOrderType.ORDER) {
          await addOrderLog(
            {
              id: orderToPrint.orderId,
              ticketId: orderToPrint.data?.product?.ticketId,
            } as IOrderLog,
            `${
              orderToPrint.data?.isReprint
                ? "Reimpressão completa"
                : "Impressão completa"
            } ${
              orderToPrint.data?.product?.ticketId
                ? `: Ticket ${orderToPrint.data.index + 1}`
                : ""
            }`,
            PrintStatus.SUCCESS
          );
        }
        removeOrder(orderToPrint.id);
        setSpoolerStatus(SpoolerStatus.standby);
      } catch (error) {
        await addOrderLog(
          {
            id: orderToPrint.orderId,
            ticketId: orderToPrint.data?.product?.ticketId,
          } as IOrderLog,
          `Falha na impressao`,
          PrintStatus.ERROR,
          error
        );
        removeOrder(orderToPrint.id);
        setSpoolerStatus(SpoolerStatus.standby);
      }
    },
    [
      getOrderToPrint,
      printRepository,
      removeOrder,
      setSpoolerStatus,
      addOrderLog,
    ]
  );

  useEffect(() => {
    addLog("PrinterProvider", {
      message: "Spooler",
      ordersToPrint,
      status: SpoolerStatus[spoolerStatus],
    });
    addLog("PrinterProvider", {
      message: "Spooler",
      ordersToPrint,
      status: SpoolerStatus[spoolerStatus],
    });
    if (
      ordersToPrint.length > 0 &&
      spoolerStatus === SpoolerStatus.standby &&
      kiosk
    ) {
      setSpoolerStatus(SpoolerStatus.isPrinting);
      printOrderHandler(kiosk);
    }
  }, [
    kiosk,
    ordersToPrint,
    printOrderHandler,
    printRepository,
    setSpoolerStatus,
    spoolerStatus,
    addLog,
  ]);

  if (!ordersToPrint || ordersToPrint.length === 0) {
    return null;
  }

  return (
    <>
      {/* <LayoutPrinterViewer ref={layoutViewerRef} /> */}
      <LayoutPrinter ref={layoutPrinterRef} />
    </>
  );
};

export default NewPrinterProvider;
